import React, { useEffect, useState, useRef } from 'react';
import {
    Box,
    Typography,
    Stack,
    Container,
    TextField,
    Divider,
    IconButton,
    InputAdornment,
    Autocomplete,
    Paper,
    Button,
    Snackbar,
} from '@mui/material';
import { useBookContext } from "../contexts/bookContext";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';


import { LocalizationProvider, MobileTimePicker, MobileDatePicker, DesktopTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ArrowBack, Visibility, VisibilityOff } from '@mui/icons-material';
import dayjs from 'dayjs';
import { DigitalClock } from '@mui/x-date-pickers/DigitalClock';

import 'dayjs/locale/ko';
import axios from "axios";
import CloseIcon from '@mui/icons-material/Close';


// 샘플 골프장 데이터
const golfCourses = [
    { label: '가평베네스트 GC' },
    { label: '남춘천 CC' },
    { label: '뉴서울 CC' },
    { label: '라비에벨 CC' },
    { label: '스카이72' },
    { label: '해비치 CC' },
];

const RegisterBooking = () => {
    const { userData, isLogin, updateUserInfo, actions } = useBookContext();
    const [init, setInit] = useState(true);
    
    const [searchParams, setSearchParams] = useSearchParams();
    const paramUserEmail = searchParams.get('userEmail') || undefined;
    const paramBookingDateStr = searchParams.get('bookDate') || undefined;

    const [showPassword, setShowPassword] = useState(false);
    const [selectedGolfCourse, setSelectedGolfCourse] = useState(null);

    // 시간/날짜 상태 관리

    const [bookingDate, setBookingDate] = useState(paramBookingDateStr);

    const [teeTimeStart, setTeeTimeStart] = useState(dayjs().hour(6).minute(0));
    const [teeTimeEnd, setTeeTimeEnd] = useState(dayjs().hour(10).minute(0));
    const [hopeTimeStart, setHopeTimeStart] = useState(dayjs().hour(6).minute(0));
    const [hopeTimeEnd, setHopeTimeEnd] = useState(dayjs().hour(10).minute(0));


    const [selectedGolfPlace, setSelectedGolfPlace] = useState(undefined);
    const [selectedCourse, setSelectedCourse] = useState(undefined);

    const [golfPlace, setGolfPlace] = useState([]); //골프장
    const [courseName, setCourseName] = useState([]); //골프장내 코스명

    const refUserId = useRef(null);
    const refUserPw = useRef(null);
    const [userPw, setUserPw] = useState('');
    const [userId, setUserId] = useState('');

    const [openDate, setOpenDate] = useState(null);
    const [openTime, setOpenTime] = useState(null);

    const [snackBarDuration, setSnackBarDuration] = useState(5000);


    const [stateSnackBar, setStateSnackBar] = React.useState({
        openSnackBar: false,
        verticalSnackBar: 'bottom',
        horizontalSnackBar: 'center',
    });

    const { verticalSnackBar, horizontalSnackBar, openSnackBar } = stateSnackBar;
    const [messageSnackBar, setMessageSnackbar] = useState('');



    const timePickerStyle = {
        flex: 1,
        minWidth: 0,
        '& .MuiInputBase-input': {
            fontSize: '0.6rem', // 폰트 크기 축소 (기본은 약 1rem)
            padding: '8.5px 8px', // 상하좌우 여백 축소
        },
        '& .MuiInputAdornment-root .MuiSvgIcon-root': {
            fontSize: '0.8rem', // 시계 아이콘 크기도 살짝 축소
        }
    };



    useEffect(() => {
        actions.extendTime(userData);
        setSelectedGolfPlace(undefined)
        setSelectedCourse(undefined)
        setCourseName([])
        setGolfPlace([])
        getGolfPlace(); 

    },[]);

    useEffect(() => {
        actions.extendTime(userData);
    }, [userData]);


    const sendToNative = (actionName, data) => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    action: actionName,
                    data: data,
                })
            );
        }
    };


    const handleSnackBarClose = () => {
        setStateSnackBar({ ...stateSnackBar, openSnackBar: false });
    };

    const showSnackBar = (msg, dur = 5000) => {
        setMessageSnackbar(msg);
        setSnackBarDuration(dur)
        setStateSnackBar({ ...stateSnackBar, openSnackBar: true })
    }

    const getGolfPlace = async () => {

        try {
            const reqData = {};
            reqData.userEmail = userData.userEmail;

            let response = await axios.post("/api/booking/GetMySelectedCourse", reqData);
            if ((response.data.code === 0)) {
                let courseData = response.data.result;
//                console.log("course :" + JSON.stringify(courseData))
                setGolfPlace(courseData);
            }
        } catch (err) {
            console.error(err);

        }
    }



    const selectGolfPlace = async (item) => {
        console.log("select course :" + JSON.stringify(item))
        setSelectedGolfPlace(item)

        var teeDate = dayjs(bookingDate);
        console.log("tee date day :" + teeDate.day())
        setCourseName([]);
        setSelectedCourse(undefined)

        setUserId(item.memberId);
        setUserPw(item.memberPw)

        if (item.courseInfo && item.courseInfo.length) {
            console.log("item.courseInfo :" + item.courseInfo);
            var info = JSON.parse(item.courseInfo);
            console.log("parse courseInfo :" + JSON.stringify(info.courses));
            if (info && info.courses && info.courses.length > 0) {
                setCourseName(info.courses);
            }

        } else {

        }


        var bookingDay = await getOpenDate(item.serial)

        if (bookingDay) {
            console.log("booking date  :" + bookingDay.format("YYYY-MM-DD HH:mm"))


            setOpenDate(bookingDay);
            setOpenTime(bookingDay);

        } else {
            console.log("selectGolfPlace get getOpenDate undefined")
        }

    }


    const getOpenDate = async (serial) => {

        try {
            var teeDate = dayjs(bookingDate);
            const reqData = {};
            reqData.teeUpDay = teeDate.format("YYYY-MM-DD HH:mm:ss");
            reqData.courseSerial = serial;

            var response = await axios.post("/api/booking/GetOpenDate", reqData);
            console.log('getOpenDate :' + JSON.stringify(response.data))

            if (response.data.code === 0) {
                return dayjs(response.data.result)
            } else {
                return undefined;
            }


        } catch (ex) {
            console.error('getOpenDate :' + ex)
            return undefined;
        }
    }


    const onStartChange = (value) => {
        setTeeTimeStart(value)
        setHopeTimeStart(value)

        if (!teeTimeEnd || teeTimeEnd < value) {
            setTeeTimeEnd(value)
            setHopeTimeEnd(value)
        }
    };

    const onEndChange = (value) => {
        if (teeTimeStart && teeTimeStart > value) {
            return;
        }

        setTeeTimeEnd(value)
        setHopeTimeEnd(value)


    };



    const addBookingJob = () => {

        var nSetTimeFail = 0;
        var strFail = '';

        var today = dayjs();

        var strOpen = openDate.format("YYYY-MM-DD") + " " + openTime.format("HH:mm:ss");

        var openDayjs = dayjs(strOpen);

        if (teeTimeStart > teeTimeEnd) {
            nSetTimeFail = 1;
            strFail = "티업시간을 다시 확인해주세요";
        }

        if (nSetTimeFail == 0 && teeTimeStart.add(2, "hour") > teeTimeEnd) {
            nSetTimeFail = 1;
            strFail = "티업시간은 2시간이상 간격을 두세요";
        }


        if (openDayjs < today) {
            nSetTimeFail = 1;
            strFail = "오픈시간이 현재시간보다 이전입니다<br/>오픈시간은 미래로 설정되어야 합니다";
            
        }


        if (nSetTimeFail == 1) {
            showSnackBar(strFail);
            return;
        }

        var teeupDay = dayjs(bookingDate);
        const reqData = {};
        reqData.userPhone = userData.userPhone;
        reqData.userEmail = userData.userEmail;
        reqData.unlimitUser = userData.unlimitUser;
        reqData.courseSerial = selectedGolfPlace.serial;
        reqData.courseName = selectedGolfPlace.courseName;
        //        reqData.openTime = dayjs(openDate).format("YYYY-MM-DD HH:mm:ss");
        reqData.openTime = strOpen;
        reqData.teeupDay = dayjs(bookingDate).format("YYYY-MM-DD");
        reqData.teeStart = teeTimeStart.format("HH:mm");
        reqData.teeEnd = teeTimeEnd.format("HH:mm");
        reqData.hopeStart = hopeTimeStart.format("HH:mm");
        reqData.hopeEnd = hopeTimeEnd.format("HH:mm");
        reqData.memberId = userId || '';
        reqData.memberPw = userPw || '';

        if (selectedCourse) {
            reqData.selCourse = selectedCourse.value;
        }



        axios
            .post("/api/booking/AddBookingJob", reqData)
            .then((response) => {
                console.log('AddBookingJob result : ' + JSON.stringify(response.data));
                if ((response.data.code === 0)) {
                    let userInfo = response.data.result;
                    showSnackBar("부킹예약 성공", 1000);
                    sendToNative('addBookingJob','success')
                } else {
                    showSnackBar(response.data.reason);

                }

            })
            .catch((err) => {
                console.error(err);
            });
    }



    const renderCourse = () => {
        if (courseName.length < 1) {
            return null;
        }

        return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ width: 90, fontWeight: 'bold', flexShrink: 0 }}>코스</Typography>
                <Autocomplete
                    fullWidth
                    options={courseName}
                    getOptionLabel={(option) => {
                        // for example value selected with enter, right from the input
                        if (option.name) {
                            return option.name;
                        }
                        return option.name;
                    }}

                    value={selectedCourse}
                    onChange={(event, newValue) => setSelectedCourse(newValue)}
                    renderInput={(params) => (
                        <TextField {...params} placeholder="코스 선택" size="small" />
                    )}
                />

            </Box>
        )
    }


    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <Container maxWidth="xs" sx={{  minHeight: '100vh', pb: 4, px: 2 }}>

                <Stack spacing={3} sx={{ mt: 2, pt : 8 }}>
                    {/* 티업일자 */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ width: 90, fontWeight: 'bold', flexShrink: 0 }}>티업일자</Typography>
                        <Typography sx={{ color: '#1976d2', fontWeight: 'bold' }}>{bookingDate}</Typography>
                        
                    </Box>

                    {/* 골프장 선택 */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ width: 90, fontWeight: 'bold', flexShrink: 0 }}>골프장</Typography>
                        <Autocomplete
                            fullWidth
                            options={golfPlace}
                            getOptionLabel={(option) => {
                                // for example value selected with enter, right from the input
                                if (typeof option === 'string') {
                                    return option;
                                } else {
//                                    console.log("getOptionLable :" + JSON.stringify(option))
                                }
                                if (option.courseName) {
                                    return option.courseName;
                                }
                                if (option.inputValue) {
                                    return option.inputValue;
                                }
                                return option.courseName;
                            }}

                            value={selectedGolfPlace}
                            onChange={(event, newValue) => selectGolfPlace(newValue)}
                            renderInput={(params) => (
                                <TextField {...params} placeholder="골프장 선택" size="small" />
                            )}
                        />
                    </Box>

                    {renderCourse()}

                    {/* 티업시간 - 레이아웃 수정 핵심 부분 */}
                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Typography sx={{ width: 90, fontWeight: 'bold', mt: 1, flexShrink: 0 }}>티업시간</Typography>
                        <Stack direction="row" spacing={1} alignItems="center" sx={{ flexGrow: 1, minWidth: 0 }}>
                            <DesktopTimePicker
                                value={teeTimeStart}
                                views={['hours', 'minutes']}
                                format="HH:mm"
                                onChange={onStartChange}
                                slotProps={{
                                    textField: { size: 'small', sx: timePickerStyle }
                                }}
                            />
                            <Typography sx={{ flexShrink: 0 }}>~</Typography>
                            <DesktopTimePicker
                                value={teeTimeEnd}
                                views={['hours', 'minutes']}
                                format="HH:mm"
                                onChange={onEndChange}
                                slotProps={{
                                    textField: { size: 'small', sx: timePickerStyle }
                                }}
                            />
                        </Stack>
                    </Box>


                    {/* 오픈일 */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ width: 90, fontWeight: 'bold', flexShrink: 0 }}>오픈일</Typography>
                        <MobileDatePicker
                            value={openDate}
                            onChange={setOpenDate}
                            format="YYYY-MM-DD"
                            slotProps={{
                                textField: {
                                    size: 'small',
                                    fullWidth: true,
                                    placeholder: '일자선택',
                                }
                            }}
                        />
                    </Box>

                    {/* 오픈시간 */}
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography sx={{ width: 90, fontWeight: 'bold', flexShrink: 0 }}>오픈시간</Typography>
                            <DesktopTimePicker
                                value={openTime}
                                onChange={setOpenTime}
                                views={['hours', 'minutes']}
                                format="HH:mm"
                                slotProps={{
                                    textField: {
                                        size: 'small',
                                        fullWidth: true,
                                        placeholder: '시간선택',
                                    }
                                }}
                            />
                        </Box>
                        <Typography variant="caption" sx={{ color: '#d32f2f', ml: 11.5, mt: 0.5, display: 'block' }}>
                            * 오픈일자는 다시한번 확인바랍니다
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    {/* 회원 정보 영역 */}
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                        부킹신청할 회원 정보를 입력하세요
                    </Typography>

                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ width: 90, fontWeight: 'bold', flexShrink: 0 }}>회원아이디</Typography>
                        <TextField
                            fullWidth
                            value={userId}
                            size="small"
                            placeholder="회원아이디를 입력하세요"
                        />
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ width: 90, fontWeight: 'bold', flexShrink: 0 }}>비밀번호</Typography>
                        <TextField
                            fullWidth
                            size="small"
                            type={showPassword ? 'text' : 'password'}
                            placeholder="비밀번호를 입력하세요"
                            value={userPw}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>


                    <Box sx={{ mt: 4, pt: 4, px: 2, mb: 4 }}>
                        <Button
                            variant="contained"
                            fullWidth
                            size="large"
                            onClick={() => addBookingJob()}
                            sx={{
                                py: 1.5,
                                color: 'white',
                                backgroundColor: '#009688',
                                '&:hover': { backgroundColor: '#00796b' },
                                fontWeight: 'bold',
                                borderRadius: 2
                            }}
                          >
                            부킹예약
                        </Button>
                    </Box>
                </Stack>
                <Snackbar
                    anchorOrigin={{ vertical: verticalSnackBar, horizontal: horizontalSnackBar }}
                    open={openSnackBar}
                    onClose={handleSnackBarClose}
                    message={messageSnackBar}
                    key={verticalSnackBar + horizontalSnackBar}
                    autoHideDuration={snackBarDuration}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            sx={{ p: 0.5 }}
                            onClick={handleSnackBarClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    }
                />

            </Container>
        </LocalizationProvider>
    );
};

export default RegisterBooking;